<h1>Oops... something broke</h1>

<p>Please help improve the site by <a routerLink="/feedback">letting me know</a> what happened. Detailed like what page you were on, how you got
    there, and what you were doing are very helpful. Alternatively, <a routerLink="/home">click here</a> to return home.
</p>

<div class="text-center">
    <img src="../../assets/fail.jpg">
</div>
